export class ShopSearchPaginatedDTO {
  offset?: number;
  limit?: number;
  term!: string;
  filter?: string;
}
